import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import "./ProjectStatus.css";
import API from "../../api/axiosConfig";
import TableComponent from "../../components/TableComponent";
import { useNavigate } from "react-router-dom";
import { showError } from "../../components/Toast";
import { Modal } from "react-bootstrap";
import TestPreLoader from "../TestPreLoader/TestPreLoader";

function ProjectStatus() {
  const navigate = useNavigate();

  const columns = [
    // { name: "التسلسل", key: "id" },
    { name: "إسم المشروع", key: "name" },
    { name: "قيمة المشروع", key: "budget" },
    { name: "قيمة التسويق", key: "marketingmethodstring" },
    { name: "تاريخ البدء", key: "startdate" },
    { name: "تاريخ الانتهاء", key: "deadline" },
    { name: "حالة المشروع", key: "statusstring" },
    { name: "", key: "actions" },
  ];


const [tableReloadKey, setTableReloadKey] = useState(Date.now());
const [showModal, setShowModal] = useState(false);
const [id , setId] = useState(null);
const [percentage , setPercentage] = useState(0);
const [loading , setLoading] = useState(true);

  const dropdownOptions = [
    { label: "مراحل المشروع ", route: "/projectdetails/:id" },
    { label: " المسئولين", route: "/projectmembers/:id" },
    { label: " مؤشرات الاداء", route: "/projectkpiview/:id" },
    { label: "المرفقات", route: "/projectattachments/:id" },
    { label: "المخاطر", route: "/projectrisks/:id" },
    { label: "تقرير المخاطر", route: "/riskassessmentreport/:id" },
    { label: " التكاليف", route: "/paymentvoucherproject/:id" },
    { label: "سندات الدفع" , action: (id , record) => {
      if(record.status === 3 || record.status === 2){
        showError("لا يمكن عرض سندات مشروع ملغي أو مكتمل");
      }else{
        navigate(`/projectpaymentvouchers/${id}`);
      }
    } },
    { label: "نسبة الانجاز", action: (id , record) => {
      if(record.status === 3 ){
        return `لا يمكن عرض نسبة انجاز مشروع ملغي`;
      }else if(record.status === 2){
        return `نسبة انجاز المشروع مكتمل 100%`
      }else{
        setShowModal(true);
        setId(id);
        const getPercentage = async () => {
    try {
      const response = await API.get(`/projectprogress/${id}/percentage`);
      if (response.status === 200) {
        setTableReloadKey(Date.now());
        setPercentage(response.data.percentage);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  getPercentage();
      }
    }},
   { label: "تعديل", action: (id , record) => {
      if(record.status === 3 || record.status === 2){
        showError("لا يمكن تعديل مشروع ملغي أو مكتمل");
      }else{
        navigate(`/editproject/${id}`);
      }
    } },
    { label: "الغاء", visibleIf: (record) => record.status !== 3 && record.status !== 2, action : (id) => {
      const cancelProject = async () => {
        try {
          const response = await API.get(`/projects/${id}/cancel`);
          if (response.status === 200) {
            setTableReloadKey(Date.now());
          }
        } catch (error) {
          console.log(error);
        }
      };
      cancelProject();
    } },
    { label: "تفعيل", visibleIf: (record) => record.status === 3, action : (id) => {
      const activateProject = async () => {
        try {
          const response = await API.get(`/projects/${id}/activate`);
          if (response.status === 200) {
            setTableReloadKey(Date.now());
          }
        } catch (error) {
          console.log(error);
        }
      };
      activateProject();
    } },
  ];

  

 

  return (
    <>
      <div className="project-status">


        <TableComponent
          apiUrl="/projects"
          columns={columns}
          title="تقرير المشاريع"
          titleIcon={<FontAwesomeIcon icon={faReceipt} />}
          searchDate={false}
          dropdownOptions={dropdownOptions}
          triggerReload={tableReloadKey}
        />
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>نسبة الانجاز</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>نسبة انجاز المشروع مكتمل </p><span style={{direction:"ltr"}}>{percentage ? percentage : 0}%</span>
          <progress value={percentage} max="100" style={{ width: "100%" }}></progress>
        </Modal.Body>
      </Modal>
    </>

  );
}

export default ProjectStatus;
